import { useState } from 'react'
import axios from '@fs/zion-axios'
import { useUser } from '@fs/zion-user'
import useErrorReporter from './useErrorReporter'
import useFetchData from './useFetchData'
import withNoticeWarnings from '../services/withNoticeWarnings'
import cisAxiosConfig from '../cisAxiosConfig'

const byNotName =
  (realmName) =>
  ({ name }) =>
    realmName !== name

// https://sg31b0.familysearch.org/service/ident/cis/cis-public-api/resource_RealmWebService.html
const fetchPartners = async (cisId) => {
  if (!cisId) {
    return []
  }
  const { data } = await withNoticeWarnings(
    axios.get(`/service/ident/cis/cis-public-api/v4/realm/userrealm/${cisId}`, cisAxiosConfig)
  )
  return data?.realms ?? []
}

const removePartner = async (cisId, realmName) =>
  withNoticeWarnings(
    axios.delete(
      `/service/ident/cis/cis-public-api/v4/realm/userrealm/${cisId},${encodeURIComponent(realmName)}`,
      cisAxiosConfig
    )
  )

export default function usePartners() {
  const reportError = useErrorReporter()
  const { cisId } = useUser()
  const { data: remotePartners, loading: partnersLoading } = useFetchData(fetchPartners, {
    initialData: [],
    requestFnArg: cisId,
  })
  const [localPartners, setLocalPartners] = useState(null)
  const partners = localPartners || remotePartners

  const handleRemovePartner = (realmName) => {
    const newPartners = partners.filter(byNotName(realmName))
    setLocalPartners(newPartners)
    removePartner(cisId, realmName).catch((error) => {
      setLocalPartners(localPartners)
      reportError(error)
    })
  }

  return {
    partners,
    partnersLoading,
    handleRemovePartner,
  }
}
